import React, { useState, useEffect } from "react";
import AppApi from '../utils/bridge.js'
import Nodata from './Nodata';
import icon14 from '../img/icon14.png'
import { getPersonalArticle } from '../api/api'

function Personal(props) {
    console.log(props)
    const [token, setToken] = useState()
    const [personalArticles, setPersonalArticles] = useState([])
    useEffect(() => {
        AppApi.getToken().then(res => {
            console.log(res)

            if (Boolean(res)) {
                setToken(res)
                let month = Number(props.date.getMonth() + 1) < 10 ? '0' + Number(props.date.getMonth() + 1) : Number(props.date.getMonth() + 1)
                getPersonalArticle({
                    app_token: res,
                    date: props.date.getFullYear() + '-' + month + '-' + props.date.getDate()
                }).then(res => {
                    setPersonalArticles(res.data.data)
                })
            } else {
                setToken(false)

            }
        })

    }, [''])

    useEffect(() => {

        if(token) {
            let month = Number(props.date.getMonth() + 1) < 10 ? '0' + Number(props.date.getMonth() + 1) : Number(props.date.getMonth() + 1)
            getPersonalArticle({
                app_token: token,
                date: props.date.getFullYear() + '-' + month + '-' + props.date.getDate()
            }).then(res => {
                setPersonalArticles(res.data.data)
            })
        }

    }, [props.date])

    const signIn = () => {
        AppApi.getToken(true).then(res => {
            console.log('成功')
            setToken(res)
            getPersonalArticle({
                app_token: res
            }).then(res => {
                setPersonalArticles(res.data.data)
            })
        })
    }

    const openLink = (url) => {
        AppApi.open_link({
                url: url,
                show_title_bar: true
        })
    }

    return (
        <div className="g-today-stock">
            <p className="m-tody-stock-name">
                今日新股申购
            </p>
            <div className="m-today-sotck-content">
                <div className="u-stock-header">
                    <span className="u-stockName">
                        名称/代码
                    </span>
                    <span className="u-stockDate">
                        申购日期
                    </span>
                    <span className="u-stockMore">
                        破发风险分区
                    </span>
                </div>

                {
                    props.stockList.length > 0 ?

                        props.stockList.map((item, index) => {
                            return (
                                <div className="u-today-stock-item" key={index}>
                                    <span className="u-stockName">
                                        <p >{item.name}</p>
                                        <p className="u-gray">{item.code}</p>
                                    </span>
                                    <span className="u-stockDate">
                                        {item.day}
                                    </span>
                                    <span className="u-stockMore" onClick={() => {openLink('https://lianghua.nbd.com.cn/ipo_radar/index')}}>
                                        <img src={icon14} className='u-stock-button' />
                                    </span>
                                </div>
                            )
                        })
                        :
                        <p className="no-stock">今日暂无新股申购</p>
                }




            </div>
            <div className="g-personal-aticle">
                <p className="m-tody-stock-name">
                    自选股
                </p>




                <div className="m-personal-article-content">

                    {
                        !Boolean(token) ?
                            <div className="m-sbumit" onClick={signIn}>
                                请登录
                            </div>
                            :
                            personalArticles.length > 0 ?
                            personalArticles.map((item, index) => {
                                return (
                                    <div className="u-aritlce-item" key={item.resourceId}>
                                        <p className="u-personal-article-title">
                                            {item.resourceTitle}
                                        </p>
                                        <div className="u-personal-aritcle-info">
                                            <div className="u-personal-stock">
                                                {
                                                    item.stockInfos.map(stock => {

                                                        if (stock.priceChangePercent == null) {
                                                            return
                                                        } else {
                                                            return (

                                                                <div className="u-personal-stock-item">

                                                                    <span className="u-stock-name">
                                                                        {stock.name}
                                                                    </span>
                                                                    <span className={stock.priceChangePercent > 0 ? 'u-stock-range u-red' : 'u-stock-range u-green'}>
                                                                        {stock.priceChangePercent}%
                                                                    </span>
                                                                </div>
                                                            )
                                                        }


                                                    })
                                                }

                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            :
                            <Nodata/>
                    }






                </div>

            </div>
        </div>

    )
}
export default Personal